/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SendingInputs */

const en_contact_form_sending = /** @type {(inputs: Contact_Form_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const pl_contact_form_sending = /** @type {(inputs: Contact_Form_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłanie…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Contact_Form_SendingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_sending = /** @type {((inputs?: Contact_Form_SendingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SendingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_sending(inputs)
	return en_contact_form_sending(inputs)
});